import { getRedirectUrl } from "../utils/sso-url-helper";
// TEMPORARY (preview testing only): if we're currently running under an
// Elevio preview themeVersion, pass it through as part of the post-logout
// redirect URI so the user lands back on the preview bundle instead of the
// published bundle after the IDP logout completes. The /authorize endpoint
// rejects redirect URIs with query params (Invalid Redirect Uri), but the
// /logout endpoint may be more permissive — empirically TBD. REMOVE / revert
// this branch before deploying to prod with `npm run deploy`.
const getPostLogoutRedirectUri = () => {
    const current = new URLSearchParams(window.location.search);
    const themeVersion = current.get('themeVersion');
    const themeId = current.get('themeId');
    if (!themeVersion)
        return getRedirectUrl('/en');
    const url = new URL(`${window.location.origin}/en/`);
    url.searchParams.set('themeVersion', themeVersion);
    if (themeId)
        url.searchParams.set('themeId', themeId);
    return url.toString();
};
export const BHIdpLogout = (SID, clientId, ssoBaseUrl) => {
    const params = new URLSearchParams({
        client_id: clientId,
        sid: SID,
        post_logout_redirect_uri: getPostLogoutRedirectUri(),
    });
    window.location.href = `${ssoBaseUrl}/logout?${params.toString()}`;
};
